import React, { Component } from 'react';

import './Deliveries.css';

import { background_10, services1 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Documents from '../../components/Documents/Documents';
import { DOCUMENT_CATEGORIES } from '../../utils/documents';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}
interface State{
}

class Deliveries extends Component<Props,State>{
    render(){
        return (
        <Page 
            id="deliveries"
            banner={{
                title: "deliveries",
                bannerImage: background_10,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - Deliveries') }</title>
                <meta 
                    name="description" 
                    content="The DAMPS deliveries updates"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    {
                        DOCUMENT_CATEGORIES["Deliveries"]?.map((category:string, index:number)=>(
                            <Documents
                                default_toggled={index === 0}
                                category={category}
                            />
                        ))
                    }
                </div>
            </div>
        </Page>
        );
    }

};


export default Deliveries;
